module.exports = __webpack_public_path__ + "static/media/argos-pg2.b646084d.jpg";